import SliderControl from './SliderControl';

export default SliderControl;
